import { theme } from "../theme.js";

export default function LoadingOverlay({ isVisible, message = "Chargement..." }) {
  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      {/* Blurred background wrapper */}
      <div style={styles.blurredBackground} />
      
      {/* Loading content */}
      <div style={styles.content}>
        {/* Animated spinner circle */}
        <div style={styles.spinnerContainer}>
          <svg style={styles.spinner} viewBox="0 0 50 50">
            <circle
              cx="25"
              cy="25"
              r="20"
              style={styles.circle}
            />
          </svg>
        </div>
        
        {/* Message text */}
        {message && <p style={styles.message}>{message}</p>}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  blurredBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
  },
  content: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    zIndex: 1,
  },
  spinnerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
  },
  spinner: {
    width: "100%",
    height: "100%",
    animation: "spin 2s linear infinite",
  },
  circle: {
    fill: "none",
    stroke: theme.colors.light,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "80",
    strokeDashoffset: "0",
    animation: "dash 1.5s ease-in-out infinite",
  },
  message: {
    color: theme.colors.light,
    fontSize: "16px",
    fontWeight: "500",
    margin: 0,
    textAlign: "center",
  },
};

// Add keyframe animations
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 5, 80;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 40, 80;
        stroke-dashoffset: -25;
      }
      100% {
        stroke-dasharray: 5, 80;
        stroke-dashoffset: -80;
      }
    }
  `;
  document.head.appendChild(styleSheet);
}
